GP.models.Thread = Backbone.Model.extend({
    idAttribute:'thread_id',
    defaults: {
        ctime: null,
        gold_initiated: false,
        message: null,
        msg_id: null,
        my_duid: null,
        newest_msg_id: null,
        newest_unread_msg_id: null,
        other_duid: null,
        sender_duid: null,
        thread_id: null,
        total: null,
        unread_total: null,
        tag: [],
        other_unread: null
    },
    initialize: function() {
        this.set('messages', new GP.collections.Messages());
    }
});
